var map = {
	"./privacy_el-GR.md": [
		3865,
		865
	],
	"./privacy_en-GB.md": [
		7907,
		907
	],
	"./privacy_fr-BE.md": [
		2414,
		414
	],
	"./privacy_ja-JP.md": [
		5958,
		958
	],
	"./privacy_nl-BE.md": [
		6268,
		268
	],
	"./privacy_pt-BR.md": [
		2691,
		691
	],
	"./privacy_pt-PT.md": [
		3779,
		779
	],
	"./privacy_zh-TW.md": [
		2156,
		156
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2226;
module.exports = webpackAsyncContext;